import React, { ReactNode } from 'react'
import dynamic from 'next/dynamic'
import useReduxModal from '@src/hooks/useModal'
import BasicButton from '../../button/BasicButton/BasicButton'
import errorLottie from 'public/lotties/error.json'
import warningLottie from 'public/lotties/warning.json'
import checkLottie from 'public/lotties/check.json'
import parse from 'html-react-parser'
import * as S from './WevAlertModal.styled'

const Lottie = dynamic(() => import('lottie-react'), { ssr: false })
interface IProps {
  type: 'error' | 'warning' | 'success' | 'custom'
  title?: string
  subTitle?: string
  buttonText?: string
  desc?: string
  confirmFunc?: any
  children?: ReactNode
}
const WevAlertModal = ({ type = 'error', title, subTitle, buttonText, desc, confirmFunc, children }: IProps) => {
  const modal = useReduxModal()
  if (type === 'error') {
    return (
      <S.ConfirmWrapper>
        <S.LottieWrapper>
          <Lottie animationData={errorLottie} loop={false} />
        </S.LottieWrapper>
        <S.Title className="mb-[10px]">{title}</S.Title>
        {desc && (
          <S.Desc className="mb-[30px]" dangerouslySetInnerHTML={{ __html: desc.replace(/\n/g, '<br/>') }}></S.Desc>
        )}
        <BasicButton
          useType="Input"
          color="Line"
          onClick={() => {
            modal.closeModal()
            confirmFunc ? confirmFunc() : null
          }}
        >
          {buttonText ? buttonText : '확인'}
        </BasicButton>
      </S.ConfirmWrapper>
    )
  } else if (type === 'warning') {
    return (
      <S.ConfirmWrapper>
        <S.LottieWrapper>
          <Lottie animationData={warningLottie} loop={false} />
        </S.LottieWrapper>
        <S.Title className="mb-[10px]">{title}</S.Title>
        <S.Desc className="mb-[30px]">{desc}</S.Desc>
        <BasicButton
          useType="Input"
          color="Line"
          onClick={() => {
            modal.closeModal()
            confirmFunc ? confirmFunc() : null
          }}
        >
          {buttonText ? buttonText : '확인'}
        </BasicButton>
      </S.ConfirmWrapper>
    )
  } else if (type === 'custom') {
    return <S.ConfirmWrapper>{children}</S.ConfirmWrapper>
  } else {
    return (
      <S.ConfirmWrapper>
        <S.Title className="mb-[30px]">{title}</S.Title>
        {children ? (
          children
        ) : (
          <S.LottieWrapper>
            <Lottie animationData={checkLottie} loop={false} />
          </S.LottieWrapper>
        )}
        {desc && <S.Desc className="mt-[20px]">{parse(desc)}</S.Desc>}
        <BasicButton
          useType="Input"
          style={{ marginTop: '30px' }}
          color="Filled"
          onClick={() => {
            modal.closeModal()
            confirmFunc ? confirmFunc() : null
          }}
        >
          {buttonText ? buttonText : '확인'}
        </BasicButton>
      </S.ConfirmWrapper>
    )
  }
}

export default WevAlertModal
